if(typeof AI == "undefined") {
	AI = {};
}

(function (AI) {
	'use strict';

	var misc = function() {
		this.misc = {};
	};

	misc.prototype = {

    	/**
    	 * [initialize description]
    	 * @return {[type]} [description]
    	 */
        init: function() {
        	this.startSelectPicker();
            this.startCarousels();
            this.toggleAdvancedSearch();
            this.startScrollSpy();
        },

        /**
         * [startSelectPicker description]
         * @return {[type]} [description]
         */
        startSelectPicker: function() {
        	$('.selectpicker').selectpicker();
        },

        /**
         * [startCarousels description]
         * @return {[type]} [description]
         */
        startCarousels: function() {
            if ($('.cycle-slideshow-template-1').length > 0) {
                $('.cycle-slideshow-template-1').slick({
                    dots: true,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 5000
                });
            }

            if ($('.cycle-slideshow-template-14').length > 0) {
                $('.cycle-slideshow-template-14').slick({
                    dots: true,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 5000
                });
            }

            if ($('.cycle-slideshow').length > 0) {
                $('.cycle-slideshow').slick({
                    dots: true,
                    infinite: true
                });
            }

            if ($('.cycle-carousel').length > 0) {
                $('.cycle-carousel').slick({
                    dots: true,
                    infinite: true,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: true,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                                infinite: true,
                                dots: true
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
            }

            if ($('.featured-carousels').length > 0) {
                this.startFeaturedCarousels();
            }
        },

        /**
         * [startFeaturedCarousels description]
         * @return {[type]} [description]
         */
        startFeaturedCarousels: function() {
            $('.feature-cycle-slideshow.text').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor: '.feature-cycle-slideshow.img',
                dots: true,
                arrows: true,
                fade: true
            });

            $('.feature-cycle-slideshow.img').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                fade: true,
                asNavFor: '.feature-cycle-slideshow.text'
            });
        },

        /**
         * [toggleAdvancedSearch description]
         * @return {[type]} [description]
         */
        toggleAdvancedSearch: function() {
            if ($('#advancedSearch').length > 0) {
                $('#advancedSearch').on( "click", function() {
                    $('.bar-filters').toggle();
                });
            }
        },

        /**
         * [startScrollSpy description]
         * @return {[type]} [description]
         */
        startScrollSpy: function () {
            $('body').scrollspy({ target: '#bs-example-navbar-collapse-1', offset: 80 });
        },

        /**
         * [getFile description]
         * @param  {[type]} file_id [description]
         * @return {[type]}         [description]
         */
        getFile: function(file_id) {
            var property_id = $('#property_source_id').html();
            return $.ajax({
                url: APP.properties_url + property_id + '/download/' + file_id,
                dataType: 'json',
                type: 'GET',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
        }

    };

	AI.misc = new misc();

})(AI);

AI.misc.init();



// WEBPACK FOOTER //
// ./resources/assets/js/ai/misc.js